import type { ComponentPropsWithoutRef } from "react";

import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselThumbnails,
} from "~/components/ui/carousels/carousel";
import { Image } from "~/components/ui/image";
import { cn } from "~/utils/classnames";

interface ImageGalleryCarouselProps extends ComponentPropsWithoutRef<"div"> {
  images: string[];
  alt: string;
}

export function ImageGalleryCarousel({
  images,
  alt,
  className,
  ...props
}: ImageGalleryCarouselProps) {
  return (
    <>
      {images && images?.length > 0 ? (
        <Carousel
          opts={{
            align: "center",
          }}
          className={className}
          {...props}
        >
          <CarouselContent
            className="-ml-0 max-h-64 sm:max-h-72 md:max-h-80 lg:max-h-96"
            containerClassName="rounded-xl border border-grey-200"
          >
            {images.map((image, index) => (
              <CarouselItem key={index} className="pl-0">
                <Image
                  src={image}
                  alt={`${alt}${index === 0 ? "" : ` - ${index + 2}`}`}
                  className="h-full w-full bg-white object-contain p-4"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mx-auto mt-4 flex items-center justify-between gap-4">
            {images && images?.length > 1 ? (
              <CarouselPrevious className="static hidden translate-x-0 translate-y-0 sm:inline-flex" />
            ) : null}
            {images && images?.length > 1 ? <CarouselThumbnails images={images} alt={alt} /> : null}
            {images && images?.length > 1 ? (
              <CarouselNext className="static hidden translate-x-0 translate-y-0 sm:inline-flex" />
            ) : null}
          </div>
          <CarouselDots />
        </Carousel>
      ) : (
        <Image
          src={images?.[0] || ""}
          alt={alt}
          className={cn("mx-auto max-h-64 sm:max-h-72 md:max-h-80 lg:max-h-96", className)}
        />
      )}
    </>
  );
}
